module.exports = __webpack_public_path__ + "img/guihua-2.643cbfef.jpg";